import React from 'react';
import { authService } from '../services/auth.service';

interface Props {
  rolesAutorises: string[];
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export default function ProtectionRole({ rolesAutorises, children, fallback }: Props) {
  const user = authService.getUser();

  if (!user || !rolesAutorises.includes(user.role)) {
    return fallback ? (
      <>{fallback}</>
    ) : (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '60vh',
        gap: 16,
        color: '#888',
      }}>
        <div style={{ fontSize: 48 }}>🔒</div>
        <div style={{ fontSize: 20, fontWeight: 600, color: '#0F172A' }}>
          Accès refusé
        </div>
        <div style={{ fontSize: 14, textAlign: 'center', maxWidth: 400 }}>
          Vous n'avez pas les permissions nécessaires pour accéder à ce module.
          Contactez votre administrateur.
        </div>
        <div style={{
          background: '#FCEBEB',
          color: '#A32D2D',
          padding: '6px 14px',
          borderRadius: 20,
          fontSize: 12,
          fontWeight: 600,
        }}>
          Rôle requis : {rolesAutorises.join(' ou ')}
        </div>
      </div>
    );
  }

  return <>{children}</>;
}